import { useState } from 'react';
import { useT } from '@/i18n';
import { useGameStore } from '@/state/gameStore';
import './TitleScreen.css';

interface TitleScreenProps {
  onEnterTerminal: () => void;
}

export function TitleScreen({ onEnterTerminal }: TitleScreenProps) {
  const player = useGameStore((s) => s.player);
  const createNewPlayer = useGameStore((s) => s.createNewPlayer);
  const resetPlayer = useGameStore((s) => s.resetPlayer);
  const t = useT();

  const [showNameInput, setShowNameInput] = useState(false);
  const [name, setName] = useState('');

  const handleCreate = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    createNewPlayer(trimmed);
    setShowNameInput(false);
    setName('');
  };

  return (
    <div className="title-screen">
      <div className="title-screen__scanlines" aria-hidden />
      <div className="title-screen__content">
        <h1 className="title-screen__logo">{t.app.title}</h1>
        <p className="title-screen__tagline">{t.app.tagline}</p>

        {player && !showNameInput && (
          <div className="title-screen__runner">
            <div className="title-screen__runner-name">{player.name}</div>
            <div className="title-screen__runner-meta">
              {t.hud.level} {player.level} · {player.credits} {t.hud.credits}
            </div>
          </div>
        )}

        {!showNameInput && (
          <div className="title-screen__actions">
            {player ? (
              <>
                <button className="btn btn--primary" onClick={onEnterTerminal}>
                  {t.title.continueRunner}
                </button>
                <button className="btn btn--ghost" onClick={resetPlayer}>
                  {t.title.newRunner}
                </button>
              </>
            ) : (
              <button className="btn btn--primary" onClick={() => setShowNameInput(true)}>
                {t.title.newRunner}
              </button>
            )}
          </div>
        )}

        {showNameInput && (
          <div className="title-screen__form">
            <input
              className="title-screen__input"
              autoFocus
              placeholder={t.title.placeholderName}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleCreate();
                if (e.key === 'Escape') setShowNameInput(false);
              }}
            />
            <div className="title-screen__form-actions">
              <button className="btn btn--primary" onClick={handleCreate} disabled={!name.trim()}>
                {t.title.create}
              </button>
              <button className="btn btn--ghost" onClick={() => setShowNameInput(false)}>
                {t.title.cancel}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
